import ga from '../utils/ga'

export const reportItemViewExpansion = (itemId: number) => {
  ga('send', 'event', 'PD Search', 'ExpandView', itemId)
}
